module.exports = __webpack_public_path__ + "static/logo.45184a2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apps/bcj/logo.png
// module id = 184
// module chunks = 189712120597197 266278358803734